import { render, staticRenderFns } from "./ListLevelMailboxes.vue?vue&type=template&id=18baf94e&scoped=true&"
import script from "./ListLevelMailboxes.vue?vue&type=script&lang=js&"
export * from "./ListLevelMailboxes.vue?vue&type=script&lang=js&"
import style0 from "./ListLevelMailboxes.vue?vue&type=style&index=0&id=18baf94e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18baf94e",
  null
  
)

export default component.exports